// Meta Pixel utility functions
// Pixel ID: 1953767461903064

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const META_PIXEL_ID = '1953767461903064'

// Initialize Meta Pixel
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  // Prevent double initialization
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript.parentNode?.insertBefore(script, firstScript)

  // Initialize with Pixel ID
  window.fbq('init', META_PIXEL_ID)
}

// Track PageView event
export function trackPageView(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

// Track InitiateCheckout event (when user clicks buy button)
export function trackInitiateCheckout(value?: number, currency?: string): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      value: value || 7.29,
      currency: currency || 'USD',
      content_name: 'Sanar en Movimiento',
      content_type: 'product',
    })
  }
}

// Generic track event function for future use
export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}
